'use client';

import React, { useEffect, useRef } from 'react';

export default function AboutStory() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => { entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('active'); }); },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal, .reveal-left, .reveal-right')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-background w-full px-4 md:px-12 pt-14 md:pt-20 pb-12 md:pb-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 items-start">
        <div className="lg:col-span-5 reveal-left">
          <span className="inline-block px-4 py-1.5 rounded-full border border-border text-muted-foreground text-xs font-bold tracking-widest uppercase mb-4 md:mb-5">
            Who We Are
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black text-foreground tracking-tight leading-tight mb-4 md:mb-6">
            Not an events company. <span className="text-primary">A community movement.</span>
          </h2>
          <div className="alpona-divider my-4 md:my-6" />
          <div className="flex flex-col gap-3 md:gap-4">
            {[
              { label: 'Founded', value: '2022' },
              { label: 'Base', value: 'South-Central Mumbai' },
              { label: 'Flagship Event', value: 'Durga Puja' },
              { label: 'Contact', value: 'hello@hoyichoyianondo.com' },
              { label: 'Social', value: '@HOYICHOYI' },
            ]?.map((item) => (
              <div key={item?.label} className="flex items-center gap-4 border-b border-border pb-3">
                <span className="text-muted-foreground text-xs font-bold tracking-widest uppercase w-20 md:w-24 flex-shrink-0">{item?.label}</span>
                <span className="text-foreground text-sm font-semibold">{item?.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 reveal-right">
          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed mb-4 md:mb-5">
              HCAF began as a simple, soulful Saraswati Puja in 2022 - born from a shared longing among Mumbai families to reconnect with the traditions they had grown up with. What started as a small gathering quickly became something much larger: a genuine cultural movement.
            </p>
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed mb-4 md:mb-5">
              Every celebration at HCAF is crafted with meaning, love, and deep respect for tradition. We are not a commercial event company. We are a family-led, non-commercial initiative. Every hand that contributes - Bengali, Marathi, Tamil, Marwari, Gujarati - is part of the foundation.
            </p>
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed mb-5 md:mb-6">
              Our founding ethos is simple: reconnect Mumbai&apos;s diaspora communities with their cultural roots through adda, rituals, culture, and the warmth of community. Truly inclusive. Children-first. Non-commercial.
            </p>
          </div>
          <blockquote className="bg-primary/5 border-l-4 border-primary rounded-r-2xl p-5 md:p-6">
            <p className="font-display text-lg md:text-xl font-bold text-foreground italic leading-snug mb-2 md:mb-3">
              &ldquo;We&apos;re not just an event. We are a journey.&rdquo;
            </p>
            <cite className="text-muted-foreground text-sm not-italic font-semibold">— HCAF Founding Team</cite>
          </blockquote>
        </div>
      </div>
    </section>
  );
}